import type { AuthChangeEvent } from '@supabase/supabase-js';

/**
 * Transition d'auth a celebrer par un popup, ou `null` si l'evenement ne merite
 * pas d'annonce.
 *
 * - `welcome` : l'utilisateur VIENT de se connecter (action volontaire).
 * - `goodbye` : l'utilisateur vient de se deconnecter.
 */
export type AuthTransition = 'welcome' | 'goodbye';

/**
 * Decide, a partir d'un evenement `onAuthStateChange`, s'il faut afficher un
 * popup — et lequel.
 *
 * Le piege est de NE PAS souhaiter la bienvenue a chaque ouverture de l'app :
 * supabase-js rejoue l'etat courant via `INITIAL_SESSION` a chaque nouvel abonne
 * (session restauree du localStorage) et peut re-emettre `SIGNED_IN` sur un
 * simple retour au premier plan ou un rafraichissement de jeton. On ne fete donc
 * la connexion QUE sur un `SIGNED_IN` qui fait passer d'un etat SANS session a un
 * etat AVEC session (`!hadSession && hasSession`) — vraie connexion (OTP, OAuth),
 * pas une restauration ni un refresh.
 *
 * `SIGNED_OUT` est sans ambiguite : il n'arrive que sur une deconnexion reelle.
 *
 * @param event      l'evenement supabase.
 * @param hadSession y avait-il deja une session AVANT cet evenement ?
 * @param hasSession y a-t-il une session APRES cet evenement ?
 */
export function resolveAuthTransition(
  event: AuthChangeEvent,
  hadSession: boolean,
  hasSession: boolean,
): AuthTransition | null {
  if (event === 'SIGNED_OUT') return 'goodbye';
  if (event === 'SIGNED_IN' && hasSession && !hadSession) return 'welcome';
  return null;
}
